import {
    DropdownButtonText,
    DropdownWrapper,
} from "shared/components/inputs/dropdown/Dropdown.styles";

import HStack from "shared/components/layout/stack/HStack";
import VStack from "shared/components/layout/stack/VStack";
import { mediaQueries } from "shared/config/breakpoints";
import styled from "styled-components";

export const ResponsiveDropdownButtonText = styled(DropdownButtonText)`
    ${mediaQueries.small} {
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        width: auto !important;
        max-width: none !important;
        font-size: 0.85rem;
        line-height: 1.2;
        text-align: center;
    }
`;

export const ResponsiveNavigationHStack = styled(HStack)`
    ${mediaQueries.small} {
        gap: 4px;
        justify-content: flex-start;

        button {
            min-height: 28px;
            padding: 4px;

            svg {
                width: 14px;
                height: 14px;
            }
        }
    }
`;

export const ResponsiveWeekNavigationContainer = styled(VStack)`
    ${mediaQueries.small} {
        align-items: flex-start;
        width: 100%;
        gap: 8px;
    }
`;

export const ResponsiveDropdownWrapper = styled(DropdownWrapper)`
    ${mediaQueries.small} {
        width: 100% !important;

        button {
            padding: 6px 8px;
            min-height: 32px;
            height: auto !important;
            width: 100% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;

            svg {
                width: 12px;
                height: 12px;
            }
        }
    }
`;
